import { pluralChecker } from "utilities";
/**
 * component returns singular / plural / other based on number.
 * if no children passed - returns num + value.
 * <PluralChecker
 *   num={location.passed_days}
 *   singular={['minął', 'dzień']}
 *   plural={['minęły', 'dni']}
 *   other={['minęło', 'dni']}
 * >
 *  {({ num, values }) => (
 *   <span>{values[0]} {num} {values[1]}</span>
 *   )}
 * </PluralChecker>
 */
const PluralChecker = ({ num, singular, plural, other, children }) => {
  if (num === null || num === undefined) return null;
  const many = Array.isArray(singular);
  const values = [];
  let value = "";
  if (many) {
    singular.forEach((el, index) =>
      values.push(
        pluralChecker(num, {
          singular: singular[index],
          plural: plural[index],
          other: other[index],
        })
      )
    );
  } else {
    value = pluralChecker(num, { singular, plural, other });
  }
  if(children) return children({ num, values, value });
  if(many) {
    return `${num} ${values.reduce((acc, val) => acc += val + ' ', '')}`;
  }
  return `${num} ${value}`;
};

export default PluralChecker;



// WEBPACK FOOTER //
// ./src/components/PluralChecker.jsx